module.exports = __webpack_public_path__ + "media/fonts/Highway-Gothic-Wide.ttf-663a5c78dfcfe13f5c3e22c1e103440a.eot";